import React, { useState } from 'react';
import { X } from 'lucide-react';
import styled from 'styled-components';
import { adsEnabled } from '../../utils/adsEnabled';

const Wrap = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadowCard};
`;

const LinkEl = styled.a`
  display: block;
  position: relative;
`;

const Img = styled.img`
  width: 100%;
  object-fit: cover;
  display: block;
  height: ${({ $inline }) => ($inline ? '5rem' : '7rem')};
  @media (min-width: 768px) {
    height: ${({ $inline }) => ($inline ? '6rem' : '9rem')};
  }
`;

const HoverTint = styled.div`
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.colors.foreground};
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
  ${LinkEl}:hover & {
    opacity: 0.2;
  }
`;

const DismissBtn = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.55);
  color: #fff;
  &:hover {
    background: rgba(15, 23, 42, 0.75);
  }
`;

const BottomBar = styled.div`
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const AdTag = styled.span`
  padding: 0.125rem 0.5rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: rgba(15, 23, 42, 0.55);
  color: #fff;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const Sponsor = styled.span`
  font-size: 0.625rem;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
`;

function AdBanner({ ad, variant = 'full' }) {
  const [dismissed, setDismissed] = useState(false);
  if (!adsEnabled() || dismissed) return null;
  const inline = variant === 'inline';

  return (
    <Wrap>
      <LinkEl href={ad.url} target="_blank" rel="noopener noreferrer sponsored">
        <Img src={ad.image} alt={ad.title} loading="lazy" $inline={inline} />
        <HoverTint />
      </LinkEl>
      <DismissBtn type="button" onClick={() => setDismissed(true)} aria-label="Dismiss ad">
        <X size={12} />
      </DismissBtn>
      <BottomBar>
        <AdTag>Ad</AdTag>
        <Sponsor>{ad.sponsor}</Sponsor>
      </BottomBar>
    </Wrap>
  );
}

export default AdBanner;
